import { render, staticRenderFns } from "./orderForPay.vue?vue&type=template&id=591f8366&scoped=true&"
import script from "./orderForPay.vue?vue&type=script&lang=js&"
export * from "./orderForPay.vue?vue&type=script&lang=js&"
import style0 from "./orderForPay.vue?vue&type=style&index=0&id=591f8366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591f8366",
  null
  
)

export default component.exports